  export function calculateStats(submissions) {
    const stats = {
      total: submissions.length,
      plomberie: submissions.filter(s => {
        const poste = s.posteSouhaite;
        if (!poste) return false;
        // Si poste est une string, essayer de la parser
        let posteObj = poste;
        if (typeof poste === 'string') {
          try {
            posteObj = JSON.parse(poste);
          } catch (e) {
            return false;
          }
        }
        return posteObj.plomberie === true || posteObj.plomberie === 'true' || posteObj.plomberie === '1' || posteObj.plomberie === 1;
      }).length,
      peinture: submissions.filter(s => {
        const poste = s.posteSouhaite;
        if (!poste) return false;
        let posteObj = poste;
        if (typeof poste === 'string') {
          try {
            posteObj = JSON.parse(poste);
          } catch (e) {
            return false;
          }
        }
        return posteObj.peinture === true || posteObj.peinture === 'true' || posteObj.peinture === '1' || posteObj.peinture === 1;
      }).length,
      electricite: submissions.filter(s => {
        const poste = s.posteSouhaite;
        if (!poste) return false;
        let posteObj = poste;
        if (typeof poste === 'string') {
          try {
            posteObj = JSON.parse(poste);
          } catch (e) {
            return false;
          }
        }
        return posteObj.electricite === true || posteObj.electricite === 'true' || posteObj.electricite === '1' || posteObj.electricite === 1;
      }).length,
      froidClimatisation: submissions.filter(s => {
        const poste = s.posteSouhaite;
        if (!poste) return false;
        let posteObj = poste;
        if (typeof poste === 'string') {
          try {
            posteObj = JSON.parse(poste);
          } catch (e) {
            return false;
          }
        }
        return posteObj.froidClimatisation === true || posteObj.froidClimatisation === 'true' || posteObj.froidClimatisation === '1' || posteObj.froidClimatisation === 1;
      }).length,
      autre: submissions.filter(s => {
        const poste = s.posteSouhaite;
        if (!poste) return false;
        let posteObj = poste;
        if (typeof poste === 'string') {
          try {
            posteObj = JSON.parse(poste);
          } catch (e) {
            return false;
          }
        }
        return posteObj.autre === true || posteObj.autre === 'true' || posteObj.autre === '1' || posteObj.autre === 1;
      }).length,
      avecSmartphone: submissions.filter(s => s.smartphone === 'oui').length,
      avecInternet: submissions.filter(s => s.accesInternetMobile === 'oui').length,
      avecMateriel: submissions.filter(s => s.materielTravail === 'bien_equipe').length,
      avecFormation: submissions.filter(s => s.formationProfessionnelle === 'diplome' || s.formationProfessionnelle === 'formation').length,
      // Statistiques niveau de scolarisation
      scolarisationAucun: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return val === 'aucun' || val.includes('aucun') || val.includes('alphabetisation') || val.includes('alphabétisation') || val.includes('sans niveau');
      }).length,
      scolarisationCep: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return val === 'cep' || val.includes('cep') || val.includes('certificat d\'études primaires') || val.includes('certificat d\'etudes primaires');
      }).length,
      scolarisationBepc: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return val === 'bepc' || val.includes('bepc') || val.includes('brevet d\'études du premier cycle') || val.includes('brevet d\'etudes du premier cycle');
      }).length,
      scolarisationCap: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return val === 'cap' || val.includes('cap') || val.includes('cqp') || val.includes('certificat d\'aptitude professionnelle') || val.includes('certificat de qualification professionnelle');
      }).length,
      scolarisationBac: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return (val === 'bac' || val.includes('baccalauréat') || val.includes('baccalaureat')) && !val.includes('bepc');
      }).length,
      scolarisationUniversitaire: submissions.filter(s => {
        const val = s.niveauScolarisation?.toLowerCase() || '';
        return val === 'universitaire' || val.includes('universitaire') || val.includes('licence') || val.includes('master') || val.includes('diplôme universitaire') || val.includes('diplome universitaire') || val.includes('doctorat');
      }).length,
      formationDiplome: submissions.filter(s => {
        const val = s.formationProfessionnelle?.toLowerCase() || '';
        return val === 'diplome' || val.includes('diplôme') || val.includes('diplome') || val.includes('certificat') || (val.includes('cap') || val.includes('cqp')) && !val.includes('non-diplômante');
      }).length,
      formationNonDiplomante: submissions.filter(s => {
        const val = s.formationProfessionnelle?.toLowerCase() || '';
        return val === 'formation' || val.includes('formation non-diplômante') || val.includes('formation non-diplomante') || val.includes('atelier') || val.includes('apprentissage sur le tas');
      }).length,
      formationPratique: submissions.filter(s => {
        const val = s.formationProfessionnelle?.toLowerCase() || '';
        return val === 'pratique' || val.includes('apprentissage pratique') || val.includes('expérience basée') || val.includes('experience basee') || (val.includes('non') && val.includes('expérience') && val.includes('basée'));
      }).length,
      experienceMoins1: submissions.filter(s => {
        const val = s.anneesExperience?.toLowerCase() || '';
        return val === 'moins1' || val.includes('moins de 1') || val.includes('moins de 1 an');
      }).length,
      experience1a3: submissions.filter(s => {
        const val = s.anneesExperience?.toLowerCase() || '';
        return val === '1a3' || val.includes('1 à 3') || val.includes('1 a 3') || val.includes('1-3');
      }).length,
      experience4a7: submissions.filter(s => {
        const val = s.anneesExperience?.toLowerCase() || '';
        return val === '4a7' || val.includes('4 à 7') || val.includes('4 a 7') || val.includes('4-7');
      }).length,
      experience8a12: submissions.filter(s => {
        const val = s.anneesExperience?.toLowerCase() || '';
        return val === '8a12' || val.includes('8 à 12') || val.includes('8 a 12') || val.includes('8-12');
      }).length,
      experiencePlus12: submissions.filter(s => {
        const val = s.anneesExperience?.toLowerCase() || '';
        return val === 'plus12' || val.includes('plus de 12') || (val.includes('plus de') && !val.includes('moins'));
      }).length,
      competence0: submissions.filter(s => s.niveauCompetence === '0' || s.niveauCompetence === 0).length,
      competence1: submissions.filter(s => s.niveauCompetence === '1' || s.niveauCompetence === 1).length,
      competence2: submissions.filter(s => s.niveauCompetence === '2' || s.niveauCompetence === 2).length,
      competence3: submissions.filter(s => s.niveauCompetence === '3' || s.niveauCompetence === 3).length,
      competence4: submissions.filter(s => s.niveauCompetence === '4' || s.niveauCompetence === 4).length,
      competence5: submissions.filter(s => s.niveauCompetence === '5' || s.niveauCompetence === 5).length,
      competence6: submissions.filter(s => s.niveauCompetence === '6' || s.niveauCompetence === 6).length,
      competence7: submissions.filter(s => s.niveauCompetence === '7' || s.niveauCompetence === 7).length,
      competence8: submissions.filter(s => s.niveauCompetence === '8' || s.niveauCompetence === 8).length,
      competence9: submissions.filter(s => s.niveauCompetence === '9' || s.niveauCompetence === 9).length,
      competence10: submissions.filter(s => s.niveauCompetence === '10' || s.niveauCompetence === 10).length,
      lectureOuiSansProbleme: submissions.filter(s => {
        const val = s.lecturePlans?.toLowerCase() || '';
        return val === 'oui_sans_probleme' || 
               (val.includes('oui') && val.includes('sans problème')) ||
               (val.includes('oui') && val.includes('sans probleme')) ||
               (val.includes('oui') && val.includes('sans') && !val.includes('aide'));
      }).length,
      lectureOuiAide: submissions.filter(s => {
        const val = s.lecturePlans?.toLowerCase() || '';
        return val === 'oui_aide' || 
               (val.includes('oui') && (val.includes('aide') || val.includes('difficulté') || val.includes('difficulte')));
      }).length,
      lectureNon: submissions.filter(s => {
        const val = s.lecturePlans?.toLowerCase() || '';
        return val === 'non' || val.includes('pas du tout') || val.includes('pas du tout');
      }).length,
      instructions1: submissions.filter(s => s.capaciteInstructions === '1' || s.capaciteInstructions === 1).length,
      instructions2: submissions.filter(s => s.capaciteInstructions === '2' || s.capaciteInstructions === 2).length,
      instructions3: submissions.filter(s => s.capaciteInstructions === '3' || s.capaciteInstructions === 3).length,
      instructions4: submissions.filter(s => s.capaciteInstructions === '4' || s.capaciteInstructions === 4).length,
      instructions5: submissions.filter(s => s.capaciteInstructions === '5' || s.capaciteInstructions === 5).length,
      instructions6: submissions.filter(s => s.capaciteInstructions === '6' || s.capaciteInstructions === 6).length,
      instructions7: submissions.filter(s => s.capaciteInstructions === '7' || s.capaciteInstructions === 7).length,
      instructions8: submissions.filter(s => s.capaciteInstructions === '8' || s.capaciteInstructions === 8).length,
      instructions9: submissions.filter(s => s.capaciteInstructions === '9' || s.capaciteInstructions === 9).length,
      instructions10: submissions.filter(s => s.capaciteInstructions === '10' || s.capaciteInstructions === 10).length,
      // Statistiques matériel de travail
      materielBienEquipe: submissions.filter(s => s.materielTravail === 'bien_equipe' || s.materielTravail === 'Oui, je suis bien équipé').length,
      materielMinimum: submissions.filter(s => s.materielTravail === 'minimum' || s.materielTravail === 'Oui, j\'ai le minimum').length,
      materielNon: submissions.filter(s => s.materielTravail === 'non' || s.materielTravail === 'Non, je n\'ai pas d\'outils').length,
      // Statistiques smartphone
      smartphoneOui: submissions.filter(s => s.smartphone === 'oui' || s.smartphone === 'Oui').length,
      smartphoneNon: submissions.filter(s => s.smartphone === 'non' || s.smartphone === 'Non').length,
      // Statistiques accès Internet Mobile
      internetOui: submissions.filter(s => s.accesInternetMobile === 'oui' || s.accesInternetMobile === 'Oui').length,
      internetNon: submissions.filter(s => s.accesInternetMobile === 'non' || s.accesInternetMobile === 'Non').length,
      // Statistiques moyen de déplacement
      deplacementMoto: submissions.filter(s => s.moyenDeplacement === 'moto' || s.moyenDeplacement === 'Moto').length,
      deplacementVelo: submissions.filter(s => s.moyenDeplacement === 'velo' || s.moyenDeplacement === 'Vélo').length,
      deplacementTransportPublic: submissions.filter(s => s.moyenDeplacement === 'transport_public' || s.moyenDeplacement === 'Transport public').length,
      deplacementAutre: submissions.filter(s => s.moyenDeplacement === 'autre' || s.moyenDeplacement === 'Autre').length,
      // Statistiques disponibilité préférence
      disponibiliteJoursOuvrables: submissions.filter(s => {
        const pref = s.disponibilitePreference;
        if (!pref) return false;
        
        // Si pref est une string, essayer de la parser
        let prefObj = pref;
        if (typeof pref === 'string') {
          try {
            prefObj = JSON.parse(pref);
          } catch (e) {
            return false;
          }
        }
        
        // Support du nouveau format (joursOuvrables, soirs, weekend)
        // Accepter true, 'true', '1', 1
        const joursOuvrables = prefObj.joursOuvrables;
        if (joursOuvrables === true || joursOuvrables === 'true' || joursOuvrables === '1' || joursOuvrables === 1) {
          return true;
        }
        
        // Support de l'ancien format (lundiMatin, etc.) - si au moins un jour ouvrable est coché
        if (prefObj.lundiMatin || prefObj.lundiApresMidi || prefObj.mardiMatin || prefObj.mardiApresMidi || 
            prefObj.mercrediMatin || prefObj.mercrediApresMidi || prefObj.jeudiMatin || prefObj.jeudiApresMidi ||
            prefObj.vendrediMatin || prefObj.vendrediApresMidi) {
          return true;
        }
        
        return false;
      }).length,
      disponibiliteSoirs: submissions.filter(s => {
        const pref = s.disponibilitePreference;
        if (!pref) return false;
        
        // Si pref est une string, essayer de la parser
        let prefObj = pref;
        if (typeof pref === 'string') {
          try {
            prefObj = JSON.parse(pref);
          } catch (e) {
            return false;
          }
        }
        
        // Support du nouveau format
        // Accepter true, 'true', '1', 1
        const soirs = prefObj.soirs;
        if (soirs === true || soirs === 'true' || soirs === '1' || soirs === 1) {
          return true;
        }
        
        return false;
      }).length,
      disponibiliteWeekend: submissions.filter(s => {
        const pref = s.disponibilitePreference;
        if (!pref) return false;
        
        // Si pref est une string, essayer de la parser
        let prefObj = pref;
        if (typeof pref === 'string') {
          try {
            prefObj = JSON.parse(pref);
          } catch (e) {
            return false;
          }
        }
        
        // Support du nouveau format
        // Accepter true, 'true', '1', 1
        const weekend = prefObj.weekend;
        if (weekend === true || weekend === 'true' || weekend === '1' || weekend === 1) {
          return true;
        }
        
        // Support de l'ancien format (samedi/dimanche)
        if (prefObj.samediMatin || prefObj.samediApresMidi || prefObj.dimancheMatin || prefObj.dimancheApresMidi) {
          return true;
        }
        
        return false;
      }).length,
    };

    const postesCount = {
      'Plomberie': stats.plomberie,
      'Peinture': stats.peinture,
      'Électricité': stats.electricite,
      'Froid/Climatisation': stats.froidClimatisation,
      'Autre': stats.autre
    };
    
    const posteLePlusSouhaite = Object.entries(postesCount)
      .sort((a, b) => b[1] - a[1])[0];

    return {
      ...stats,
      posteLePlusSouhaite: posteLePlusSouhaite[1] > 0 ? posteLePlusSouhaite[0] : 'Aucun',
      posteLePlusSouhaiteCount: posteLePlusSouhaite[1]
    };
}

export function getDisponibiliteStats(submissions) {
  const disponibiliteMap = {};
  submissions.forEach(sub => {
    const disponibiliteValue = sub.disponibiliteCommencer || sub.disponibiliteJours;
    if (disponibiliteValue && disponibiliteValue.trim()) {
      const value = disponibiliteValue.trim();
      disponibiliteMap[value] = (disponibiliteMap[value] || 0) + 1;
    }
  });

  return Object.entries(disponibiliteMap)
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => b.count - a.count);
}

export function getMoyenDeplacementAutreStats(submissions) {
  const autreMap = {};
  submissions.forEach(sub => {
    if (sub.moyenDeplacement === 'autre' && sub.autreMoyenDeplacement && sub.autreMoyenDeplacement.trim()) {
      const value = sub.autreMoyenDeplacement.trim();
      autreMap[value] = (autreMap[value] || 0) + 1;
    }
  });

  return Object.entries(autreMap)
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => b.count - a.count);
}

export function mergeStats(localStats, serverStats) {
  if (!serverStats) return localStats;
  const postesCount = {
    Plomberie: serverStats.plomberie || 0,
    Peinture: serverStats.peinture || 0,
    Électricité: serverStats.electricite || 0,
    'Froid/Climatisation': serverStats.froidClimatisation || 0,
    Autre: serverStats.autre || 0,
  };
  const posteLePlusSouhaite = Object.entries(postesCount).sort((a, b) => b[1] - a[1])[0];
  return {
    ...localStats,
    ...serverStats,
    total: serverStats.total ?? localStats.total,
    avecSmartphone:
      serverStats.avecSmartphone ?? serverStats.smartphoneOui ?? localStats.avecSmartphone,
    avecInternet:
      serverStats.avecInternet ?? serverStats.internetOui ?? localStats.avecInternet,
    posteLePlusSouhaite: posteLePlusSouhaite[1] > 0 ? posteLePlusSouhaite[0] : 'Aucun',
    posteLePlusSouhaiteCount: posteLePlusSouhaite[1],
    source: serverStats.source || 'server',
  };
}